import { ReservationActionTypes } from './reservation.types';


export const addCandidate = item => ({
    type: ReservationActionTypes.ADD_CANDIDATE,
    payload: item
});

export const removeCandidate = () => ({
    type: ReservationActionTypes.REMOVE_CANDIDATE
});

export const incrementCandidateQty = mass => ({
    type: ReservationActionTypes.INCREMENT_QTY,
    payload: mass
});

export const decrementCandidateQty = () => ({
    type: ReservationActionTypes.DECREMENT_QTY
});

export const addReservation = item => ({
    type: ReservationActionTypes.ADD_RESERVATION,
    payload: item
});


export const removeReservation = item => ({
    type: ReservationActionTypes.REMOVE_RESERVATION,
    payload: item
});

export const clearReservation = () => ({
    type: ReservationActionTypes.CLEAR_RESERVATIONS
});

export const updateUserReservations = (userReservations) => ({
    type: ReservationActionTypes.UPDATE_USER_RESERVATIONS,
    payload: userReservations
});



